/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CmsBanner_viewer$ref = any;
type Freebie_product$ref = any;
type List_viewer$ref = any;
type PriceMatch_product$ref = any;
type PriceMatch_viewer$ref = any;
type ProductStock_product$ref = any;
type ProductStock_viewer$ref = any;
type ProductView_viewer$ref = any;
type Related_product$ref = any;
type Related_viewer$ref = any;
type ReviewForm_product$ref = any;
type ReviewList_product$ref = any;
type ReviewList_viewer$ref = any;
type ShippingQuote_viewer$ref = any;
type TierPrice_product$ref = any;
type WishlistBtn_product$ref = any;
type WishlistBtn_viewer$ref = any;
export type routes_ProductView_QueryVariables = {|
  urlSlugs?: ?$ReadOnlyArray<?string>
|};
export type routes_ProductView_QueryResponse = {|
  +viewer: ?{|
    +email: ?string,
    +salesNumber: ?string,
    +freeShippingAmount: ?number,
    +products: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +alerts: ?any,
          +name: ?string,
          +type: ?string,
          +brand: ?{|
            +id: string,
            +imageUrl: ?string,
            +name: ?string,
            +urlSlug: ?string,
          |},
          +mainImage: ?{|
            +id: string,
            +url: ?string,
            +thumbnail: ?string,
          |},
          +files: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +url: ?string,
              |}
            |}>
          |},
          +images: ?$ReadOnlyArray<?{|
            +url: ?string,
            +thumbnail: ?string,
          |}>,
          +model: ?string,
          +bundles: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +model: ?string,
                +sku: ?string,
                +ac: ?string,
                +description: ?string,
                +specification: ?string,
                +warranty: ?string,
                +urlSlug: ?string,
                +quantity: ?number,
                +images: ?$ReadOnlyArray<?{|
                  +url: ?string,
                  +thumbnail: ?string,
                |}>,
              |}
            |}>
          |},
          +configurableAttributes: ?any,
          +configurables: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +type: ?string,
                +attributes: ?any,
                +model: ?string,
                +secondModel: ?string,
                +sku: ?string,
                +ac: ?string,
                +regularPrice: ?number,
                +price: ?number,
                +priceMatch: ?boolean,
                +description: ?string,
                +specification: ?string,
                +warranty: ?string,
                +urlSlug: ?string,
                +quantity: ?number,
                +sellable: ?boolean,
                +nonStock: ?boolean,
                +onlineOnly: ?boolean,
                +clearance: ?boolean,
                +callForPrice: ?boolean,
                +inStoreOnly: ?boolean,
                +sortingFactor: ?number,
                +videos: ?$ReadOnlyArray<?string>,
                +backInStockDate: ?string,
                +stockAvailable: ?number,
                +preorderDate: ?string,
                +globalFreeShipping: ?boolean,
                +freeShipping: ?boolean,
                +tierPrices: ?any,
                +discountCode: ?any,
                +loyaltyPoints: ?{|
                  +accruing: ?number,
                  +dollars: ?number,
                |},
                +images: ?$ReadOnlyArray<?{|
                  +url: ?string,
                  +thumbnail: ?string,
                |}>,
                +metaDescription: ?string,
                +status: ?string,
                +labels: ?{|
                  +edges: ?$ReadOnlyArray<?{|
                    +node: ?{|
                      +id: string,
                      +imageUrl: ?string,
                      +productPageImageUrl: ?string,
                      +placement: ?string,
                    |}
                  |}>
                |},
                +bonusProducts: ?{|
                  +edges: ?$ReadOnlyArray<?{|
                    +node: ?{|
                      +productId: ?string,
                      +productName: ?string,
                      +productUrlSlug: ?string,
                      +price: ?number,
                      +quantity: ?number,
                      +optional: ?boolean,
                    |}
                  |}>
                |},
                +$fragmentRefs: TierPrice_product$ref & PriceMatch_product$ref & ReviewForm_product$ref & ReviewList_product$ref & ProductStock_product$ref & Freebie_product$ref,
              |}
            |}>
          |},
          +secondModel: ?string,
          +sortingFactor: ?number,
          +sku: ?string,
          +ac: ?string,
          +description: ?string,
          +specification: ?string,
          +urlSlug: ?string,
          +regularPrice: ?number,
          +price: ?number,
          +priceDrop: ?boolean,
          +nonStock: ?boolean,
          +onlineOnly: ?boolean,
          +earnPoints: ?boolean,
          +videos: ?$ReadOnlyArray<?string>,
          +backInStockDate: ?string,
          +stockAvailable: ?number,
          +preorderDate: ?string,
          +globalFreeShipping: ?boolean,
          +freeShipping: ?boolean,
          +sellable: ?boolean,
          +clearance: ?boolean,
          +callForPrice: ?boolean,
          +inStoreOnly: ?boolean,
          +tierPrices: ?any,
          +warranty: ?string,
          +discountCode: ?any,
          +loyaltyPoints: ?{|
            +accruing: ?number,
            +dollars: ?number,
          |},
          +metaDescription: ?string,
          +status: ?string,
          +commonPromoBanners: ?$ReadOnlyArray<?$ReadOnlyArray<?string>>,
          +labels: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +imageUrl: ?string,
                +productPageImageUrl: ?string,
                +placement: ?string,
              |}
            |}>
          |},
          +bonusProducts: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +productId: ?string,
                +productName: ?string,
                +productUrlSlug: ?string,
                +price: ?number,
                +quantity: ?number,
                +optional: ?boolean,
              |}
            |}>
          |},
          +suggestions: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +alerts: ?any,
                +name: ?string,
                +model: ?string,
                +secondModel: ?string,
                +price: ?number,
                +sku: ?string,
                +ac: ?string,
                +urlSlug: ?string,
                +freeShipping: ?boolean,
                +preorderDate: ?string,
                +backInStockDate: ?string,
                +callForPrice: ?boolean,
                +inStoreOnly: ?boolean,
                +onlineOnly: ?boolean,
                +discountCode: ?any,
                +nonStock: ?boolean,
                +sellable: ?boolean,
                +clearance: ?boolean,
                +brand: ?{|
                  +id: string,
                  +name: ?string,
                |},
                +labels: ?{|
                  +edges: ?$ReadOnlyArray<?{|
                    +node: ?{|
                      +id: string,
                      +type: ?number,
                      +imageUrl: ?string,
                      +placement: ?string,
                    |}
                  |}>
                |},
                +mainImage: ?{|
                  +id: string,
                  +thumbnail: ?string,
                |},
              |}
            |}>
          |},
          +$fragmentRefs: TierPrice_product$ref & PriceMatch_product$ref & ReviewForm_product$ref & ReviewList_product$ref & ProductStock_product$ref & Freebie_product$ref & Related_product$ref & WishlistBtn_product$ref,
        |}
      |}>
    |},
    +$fragmentRefs: CmsBanner_viewer$ref & ShippingQuote_viewer$ref & ReviewList_viewer$ref & List_viewer$ref & PriceMatch_viewer$ref & ProductStock_viewer$ref & Related_viewer$ref & WishlistBtn_viewer$ref & ProductView_viewer$ref,
  |}
|};
export type routes_ProductView_Query = {|
  variables: routes_ProductView_QueryVariables,
  response: routes_ProductView_QueryResponse,
|};
*/


/*
query routes_ProductView_Query(
  $urlSlugs: [String]
) {
  viewer {
    ...CmsBanner_viewer
    ...ShippingQuote_viewer
    ...ReviewList_viewer
    ...List_viewer
    ...PriceMatch_viewer
    ...ProductStock_viewer
    ...Related_viewer
    ...WishlistBtn_viewer
    email
    salesNumber
    freeShippingAmount
    products(first: 1, urlSlugs: $urlSlugs) {
      edges {
        node {
          id
          alerts
          name
          type
          brand {
            id
            imageUrl
            name
            urlSlug
          }
          mainImage {
            id
            url
            thumbnail
          }
          files(first: 99) {
            edges {
              node {
                id
                name
                url
              }
            }
          }
          images {
            url
            thumbnail
            id
          }
          model
          bundles(first: 99) {
            edges {
              node {
                id
                name
                model
                sku
                ac
                description
                specification
                warranty
                urlSlug
                quantity
                images(showInKit: true) {
                  url
                  thumbnail
                  id
                }
              }
            }
          }
          configurableAttributes
          configurables(first: 99) {
            edges {
              node {
                id
                name
                type
                attributes
                model
                secondModel
                sku
                ac
                regularPrice
                price
                priceMatch
                description
                specification
                warranty
                urlSlug
                quantity
                sellable
                nonStock
                onlineOnly
                clearance
                callForPrice
                inStoreOnly
                sortingFactor
                videos
                backInStockDate
                stockAvailable
                preorderDate
                globalFreeShipping
                freeShipping
                ...TierPrice_product
                tierPrices
                discountCode
                loyaltyPoints {
                  accruing
                  dollars
                }
                images(showInKit: true) {
                  url
                  thumbnail
                  id
                }
                metaDescription
                status
                labels(first: 999) {
                  edges {
                    node {
                      id
                      imageUrl
                      productPageImageUrl
                      placement
                    }
                  }
                }
                bonusProducts(first: 999) {
                  edges {
                    node {
                      productId
                      productName
                      productUrlSlug
                      price
                      quantity
                      optional
                      id
                    }
                  }
                }
                ...PriceMatch_product
                ...ReviewForm_product
                ...ReviewList_product
                ...ProductStock_product
                ...Freebie_product
              }
            }
          }
          secondModel
          sortingFactor
          sku
          ac
          description
          specification
          urlSlug
          regularPrice
          price
          priceDrop
          nonStock
          onlineOnly
          earnPoints
          videos
          backInStockDate
          stockAvailable
          preorderDate
          globalFreeShipping
          freeShipping
          sellable
          clearance
          callForPrice
          inStoreOnly
          ...TierPrice_product
          tierPrices
          warranty
          discountCode
          loyaltyPoints {
            accruing
            dollars
          }
          metaDescription
          status
          commonPromoBanners
          labels(first: 999) {
            edges {
              node {
                id
                imageUrl
                productPageImageUrl
                placement
              }
            }
          }
          bonusProducts(first: 999) {
            edges {
              node {
                productId
                productName
                productUrlSlug
                price
                quantity
                optional
                id
              }
            }
          }
          suggestions(first: 12) {
            edges {
              node {
                id
                alerts
                name
                model
                secondModel
                price
                sku
                ac
                urlSlug
                freeShipping
                preorderDate
                backInStockDate
                callForPrice
                inStoreOnly
                onlineOnly
                discountCode
                nonStock
                sellable
                clearance
                brand {
                  id
                  name
                }
                labels(first: 999) {
                  edges {
                    node {
                      id
                      type
                      imageUrl
                      placement
                    }
                  }
                }
                mainImage {
                  id
                  thumbnail
                }
              }
            }
          }
          ...PriceMatch_product
          ...ReviewForm_product
          ...ReviewList_product
          ...ProductStock_product
          ...Freebie_product
          ...Related_product
          ...WishlistBtn_product
        }
      }
    }
    ...ProductView_viewer
    id
  }
}

fragment CmsBanner_viewer on Customer {
  cmsBanners(first: 999) {
    edges {
      node {
        id
        title
        link
        urlPaths
        categoryBig
        categorySmall
      }
    }
  }
}

fragment Freebie_product on Product {
  price
  freebies(first: 99) {
    edges {
      node {
        id
        tiers(first: 99) {
          edges {
            node {
              id
              price
              quantity
              mode
              products(first: 99) {
                edges {
                  node {
                    id
                    name
                    urlSlug
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

fragment List_viewer on Customer {
  id
  ...ProductCard_viewer
}

fragment PriceMatch_product on Product {
  id
  name
  priceMatch
}

fragment PriceMatch_viewer on Customer {
  id
}

fragment ProductCard_viewer on Customer {
  id
  freeShippingAmount
}

fragment ProductStock_product on Product {
  id
  ac
  preorderDate
  backInStockDate
}

fragment ProductStock_viewer on Customer {
  id
  email
  myStore {
    id
  }
}

fragment ProductView_viewer on Customer {
  ...CmsBanner_viewer
  ...ShippingQuote_viewer
  ...ReviewList_viewer
  ...List_viewer
  ...PriceMatch_viewer
  ...ProductStock_viewer
  ...Related_viewer
  ...WishlistBtn_viewer
  email
  salesNumber
  freeShippingAmount
  products(first: 1, urlSlugs: $urlSlugs) {
    edges {
      node {
        id
        alerts
        name
        type
        brand {
          id
          imageUrl
          name
          urlSlug
        }
        mainImage {
          id
          url
          thumbnail
        }
        files(first: 99) {
          edges {
            node {
              id
              name
              url
            }
          }
        }
        images {
          url
          thumbnail
          id
        }
        model
        bundles(first: 99) {
          edges {
            node {
              id
              name
              model
              sku
              ac
              description
              specification
              warranty
              urlSlug
              quantity
              images(showInKit: true) {
                url
                thumbnail
                id
              }
            }
          }
        }
        configurableAttributes
        configurables(first: 99) {
          edges {
            node {
              id
              name
              type
              attributes
              model
              secondModel
              sku
              ac
              regularPrice
              price
              priceMatch
              description
              specification
              warranty
              urlSlug
              quantity
              sellable
              nonStock
              onlineOnly
              clearance
              callForPrice
              inStoreOnly
              sortingFactor
              videos
              backInStockDate
              stockAvailable
              preorderDate
              globalFreeShipping
              freeShipping
              ...TierPrice_product
              tierPrices
              discountCode
              loyaltyPoints {
                accruing
                dollars
              }
              images(showInKit: true) {
                url
                thumbnail
                id
              }
              metaDescription
              status
              labels(first: 999) {
                edges {
                  node {
                    id
                    imageUrl
                    productPageImageUrl
                    placement
                  }
                }
              }
              bonusProducts(first: 999) {
                edges {
                  node {
                    productId
                    productName
                    productUrlSlug
                    price
                    quantity
                    optional
                    id
                  }
                }
              }
              ...PriceMatch_product
              ...ReviewForm_product
              ...ReviewList_product
              ...ProductStock_product
              ...Freebie_product
            }
          }
        }
        secondModel
        sortingFactor
        sku
        ac
        description
        specification
        urlSlug
        regularPrice
        price
        priceDrop
        nonStock
        onlineOnly
        earnPoints
        videos
        backInStockDate
        stockAvailable
        preorderDate
        globalFreeShipping
        freeShipping
        sellable
        clearance
        callForPrice
        inStoreOnly
        ...TierPrice_product
        tierPrices
        warranty
        discountCode
        loyaltyPoints {
          accruing
          dollars
        }
        metaDescription
        status
        commonPromoBanners
        labels(first: 999) {
          edges {
            node {
              id
              imageUrl
              productPageImageUrl
              placement
            }
          }
        }
        bonusProducts(first: 999) {
          edges {
            node {
              productId
              productName
              productUrlSlug
              price
              quantity
              optional
              id
            }
          }
        }
        suggestions(first: 12) {
          edges {
            node {
              id
              alerts
              name
              model
              secondModel
              price
              sku
              ac
              urlSlug
              freeShipping
              preorderDate
              backInStockDate
              callForPrice
              inStoreOnly
              onlineOnly
              discountCode
              nonStock
              sellable
              clearance
              brand {
                id
                name
              }
              labels(first: 999) {
                edges {
                  node {
                    id
                    type
                    imageUrl
                    placement
                  }
                }
              }
              mainImage {
                id
                thumbnail
              }
            }
          }
        }
        ...PriceMatch_product
        ...ReviewForm_product
        ...ReviewList_product
        ...ProductStock_product
        ...Freebie_product
        ...Related_product
        ...WishlistBtn_product
      }
    }
  }
}

fragment Related_product on Product {
  related(first: 99) {
    edges {
      node {
        id
        brand {
          id
          name
        }
        name
        type
        nonStock
        sku
        price
        urlSlug
        callForPrice
        mainImage {
          id
          thumbnail
        }
        configurables(first: 99) {
          edges {
            node {
              id
              name
              type
              nonStock
              sku
              price
              urlSlug
              callForPrice
              mainImage {
                id
                thumbnail
              }
            }
          }
        }
      }
    }
  }
}

fragment Related_viewer on Customer {
  id
}

fragment ReviewForm_product on Product {
  id
  name
}

fragment ReviewList_product on Product {
  reviews(first: 100) {
    edges {
      node {
        id
        content
        replies(first: 100) {
          edges {
            node {
              id
              content
              customer {
                firstname
                id
              }
              customerName
              insertedAt
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        ratings(first: 10) {
          edges {
            node {
              id
              star
              percentage
              ratingType {
                code
              }
            }
          }
        }
        product {
          name
          urlSlug
          mainImage {
            id
            thumbnail
          }
          id
        }
        productName
        customer {
          id
          firstname
        }
        customerName
        insertedAt
        status
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReviewList_viewer on Customer {
  id
}

fragment ShippingQuote_viewer on Customer {
  freeShippingAmount
  shippingMethods(first: 20, productId: "", suburb: "", city: "", postcode: "") {
    edges {
      node {
        code
        title
        price
        priceFormatted
        extra
        id
      }
    }
  }
}

fragment TierPrice_product on Product {
  price
  tierPrices
}

fragment WishlistBtn_product on Product {
  id
  name
  type
  callForPrice
  inStoreOnly
  inWishlist
  sellable
}

fragment WishlistBtn_viewer on Customer {
  id
  email
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "urlSlugs"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesNumber",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freeShippingAmount",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "urlSlugs",
    "variableName": "urlSlugs"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alerts",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Brand",
  "kind": "LinkedField",
  "name": "brand",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v9/*: any*/),
    (v7/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductImage",
  "kind": "LinkedField",
  "name": "mainImage",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
],
v16 = {
  "alias": null,
  "args": (v15/*: any*/),
  "concreteType": "ProductFileConnection",
  "kind": "LinkedField",
  "name": "files",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductFileEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductFile",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v7/*: any*/),
            (v12/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "files(first:99)"
},
v17 = [
  (v12/*: any*/),
  (v13/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sku",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ac",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specification",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "warranty",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "showInKit",
    "value": true
  }
],
v26 = {
  "alias": null,
  "args": (v25/*: any*/),
  "concreteType": "ProductImage",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v17/*: any*/),
  "storageKey": "images(showInKit:true)"
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configurableAttributes",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attributes",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secondModel",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regularPrice",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceMatch",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellable",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nonStock",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onlineOnly",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clearance",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callForPrice",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inStoreOnly",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortingFactor",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videos",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backInStockDate",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stockAvailable",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preorderDate",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "globalFreeShipping",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freeShipping",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tierPrices",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discountCode",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "LoyaltyPoints",
  "kind": "LinkedField",
  "name": "loyaltyPoints",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accruing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dollars",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaDescription",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v51 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 999
  }
],
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placement",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": (v51/*: any*/),
  "concreteType": "LabelConnection",
  "kind": "LinkedField",
  "name": "labels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productPageImageUrl",
              "storageKey": null
            },
            (v52/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "labels(first:999)"
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productName",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productUrlSlug",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optional",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": (v51/*: any*/),
  "concreteType": "BonusProductConnection",
  "kind": "LinkedField",
  "name": "bonusProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BonusProductEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BonusProduct",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v54/*: any*/),
            (v55/*: any*/),
            (v56/*: any*/),
            (v31/*: any*/),
            (v24/*: any*/),
            (v57/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "bonusProducts(first:999)"
},
v59 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TierPrice_product"
},
v60 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PriceMatch_product"
},
v61 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ReviewForm_product"
},
v62 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ReviewList_product"
},
v63 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ProductStock_product"
},
v64 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "Freebie_product"
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceDrop",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "earnPoints",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commonPromoBanners",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "Brand",
  "kind": "LinkedField",
  "name": "brand",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductImage",
  "kind": "LinkedField",
  "name": "mainImage",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 12
    }
  ],
  "concreteType": "ProductConnection",
  "kind": "LinkedField",
  "name": "suggestions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v18/*: any*/),
            (v29/*: any*/),
            (v31/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v10/*: any*/),
            (v45/*: any*/),
            (v43/*: any*/),
            (v41/*: any*/),
            (v37/*: any*/),
            (v38/*: any*/),
            (v35/*: any*/),
            (v47/*: any*/),
            (v34/*: any*/),
            (v33/*: any*/),
            (v36/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": (v51/*: any*/),
              "concreteType": "LabelConnection",
              "kind": "LinkedField",
              "name": "labels",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LabelEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Label",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        (v8/*: any*/),
                        (v9/*: any*/),
                        (v52/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "labels(first:999)"
            },
            (v69/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "suggestions(first:12)"
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v73 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v5/*: any*/)
],
v74 = {
  "alias": null,
  "args": (v25/*: any*/),
  "concreteType": "ProductImage",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v73/*: any*/),
  "storageKey": "images(showInKit:true)"
},
v75 = {
  "alias": null,
  "args": (v51/*: any*/),
  "concreteType": "BonusProductConnection",
  "kind": "LinkedField",
  "name": "bonusProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BonusProductEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BonusProduct",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v54/*: any*/),
            (v55/*: any*/),
            (v56/*: any*/),
            (v31/*: any*/),
            (v24/*: any*/),
            (v57/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "bonusProducts(first:999)"
},
v76 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstname",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerName",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insertedAt",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": (v76/*: any*/),
  "concreteType": "ReviewConnection",
  "kind": "LinkedField",
  "name": "reviews",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReviewEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Review",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v77/*: any*/),
            {
              "alias": null,
              "args": (v76/*: any*/),
              "concreteType": "ReviewReplyConnection",
              "kind": "LinkedField",
              "name": "replies",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ReviewReplyEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ReviewReply",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        (v77/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Customer",
                          "kind": "LinkedField",
                          "name": "customer",
                          "plural": false,
                          "selections": [
                            (v78/*: any*/),
                            (v5/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v79/*: any*/),
                        (v80/*: any*/),
                        (v81/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v82/*: any*/)
                  ],
                  "storageKey": null
                },
                (v83/*: any*/)
              ],
              "storageKey": "replies(first:100)"
            },
            {
              "alias": null,
              "args": (v76/*: any*/),
              "filters": null,
              "handle": "connection",
              "key": "ReviewList_replies",
              "kind": "LinkedHandle",
              "name": "replies"
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 10
                }
              ],
              "concreteType": "ReviewRatingConnection",
              "kind": "LinkedField",
              "name": "ratings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ReviewRatingEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ReviewRating",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "star",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "percentage",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ReviewRatingType",
                          "kind": "LinkedField",
                          "name": "ratingType",
                          "plural": false,
                          "selections": [
                            (v72/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "ratings(first:10)"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "product",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v10/*: any*/),
                (v69/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            },
            (v55/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Customer",
              "kind": "LinkedField",
              "name": "customer",
              "plural": false,
              "selections": [
                (v5/*: any*/),
                (v78/*: any*/)
              ],
              "storageKey": null
            },
            (v79/*: any*/),
            (v80/*: any*/),
            (v50/*: any*/),
            (v81/*: any*/)
          ],
          "storageKey": null
        },
        (v82/*: any*/)
      ],
      "storageKey": null
    },
    (v83/*: any*/)
  ],
  "storageKey": "reviews(first:100)"
},
v85 = {
  "alias": null,
  "args": (v76/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "ReviewList_reviews",
  "kind": "LinkedHandle",
  "name": "reviews"
},
v86 = {
  "alias": null,
  "args": (v15/*: any*/),
  "concreteType": "FreebieConnection",
  "kind": "LinkedField",
  "name": "freebies",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FreebieEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Freebie",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "alias": null,
              "args": (v15/*: any*/),
              "concreteType": "FreebieTierConnection",
              "kind": "LinkedField",
              "name": "tiers",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FreebieTierEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FreebieTier",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        (v31/*: any*/),
                        (v24/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "mode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": (v15/*: any*/),
                          "concreteType": "ProductConnection",
                          "kind": "LinkedField",
                          "name": "products",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ProductEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Product",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v5/*: any*/),
                                    (v7/*: any*/),
                                    (v10/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": "products(first:99)"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "tiers(first:99)"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "freebies(first:99)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_ProductView_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "ProductConnection",
            "kind": "LinkedField",
            "name": "products",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v11/*: any*/),
                      (v14/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductImage",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": (v15/*: any*/),
                        "concreteType": "ProductConnection",
                        "kind": "LinkedField",
                        "name": "bundles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v7/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v10/*: any*/),
                                  (v24/*: any*/),
                                  (v26/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "bundles(first:99)"
                      },
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": (v15/*: any*/),
                        "concreteType": "ProductConnection",
                        "kind": "LinkedField",
                        "name": "configurables",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v28/*: any*/),
                                  (v18/*: any*/),
                                  (v29/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v10/*: any*/),
                                  (v24/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v26/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v53/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v63/*: any*/),
                                  (v64/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "configurables(first:99)"
                      },
                      (v29/*: any*/),
                      (v39/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v10/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v65/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v66/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v33/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v46/*: any*/),
                      (v23/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v67/*: any*/),
                      (v53/*: any*/),
                      (v58/*: any*/),
                      (v70/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/),
                      (v64/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "Related_product"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "WishlistBtn_product"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CmsBanner_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShippingQuote_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReviewList_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "List_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PriceMatch_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductStock_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Related_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WishlistBtn_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductView_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_ProductView_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v51/*: any*/),
            "concreteType": "CmsBannerConnection",
            "kind": "LinkedField",
            "name": "cmsBanners",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CmsBannerEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CmsBanner",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v71/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "link",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlPaths",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "categoryBig",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "categorySmall",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "cmsBanners(first:999)"
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "city",
                "value": ""
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              },
              {
                "kind": "Literal",
                "name": "postcode",
                "value": ""
              },
              {
                "kind": "Literal",
                "name": "productId",
                "value": ""
              },
              {
                "kind": "Literal",
                "name": "suburb",
                "value": ""
              }
            ],
            "concreteType": "ShippingRateConnection",
            "kind": "LinkedField",
            "name": "shippingMethods",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ShippingRateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShippingRate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v72/*: any*/),
                      (v71/*: any*/),
                      (v31/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceFormatted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "extra",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "shippingMethods(city:\"\",first:20,postcode:\"\",productId:\"\",suburb:\"\")"
          },
          (v5/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "myStore",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "ProductConnection",
            "kind": "LinkedField",
            "name": "products",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v11/*: any*/),
                      (v14/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductImage",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": (v73/*: any*/),
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": (v15/*: any*/),
                        "concreteType": "ProductConnection",
                        "kind": "LinkedField",
                        "name": "bundles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v7/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v10/*: any*/),
                                  (v24/*: any*/),
                                  (v74/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "bundles(first:99)"
                      },
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": (v15/*: any*/),
                        "concreteType": "ProductConnection",
                        "kind": "LinkedField",
                        "name": "configurables",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v28/*: any*/),
                                  (v18/*: any*/),
                                  (v29/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v10/*: any*/),
                                  (v24/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v74/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v53/*: any*/),
                                  (v75/*: any*/),
                                  (v84/*: any*/),
                                  (v85/*: any*/),
                                  (v86/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "configurables(first:99)"
                      },
                      (v29/*: any*/),
                      (v39/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v10/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v65/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v66/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v33/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v46/*: any*/),
                      (v23/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v67/*: any*/),
                      (v53/*: any*/),
                      (v75/*: any*/),
                      (v70/*: any*/),
                      (v32/*: any*/),
                      (v84/*: any*/),
                      (v85/*: any*/),
                      (v86/*: any*/),
                      {
                        "alias": null,
                        "args": (v15/*: any*/),
                        "concreteType": "ProductConnection",
                        "kind": "LinkedField",
                        "name": "related",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v68/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v34/*: any*/),
                                  (v19/*: any*/),
                                  (v31/*: any*/),
                                  (v10/*: any*/),
                                  (v37/*: any*/),
                                  (v69/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v15/*: any*/),
                                    "concreteType": "ProductConnection",
                                    "kind": "LinkedField",
                                    "name": "configurables",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v7/*: any*/),
                                              (v8/*: any*/),
                                              (v34/*: any*/),
                                              (v19/*: any*/),
                                              (v31/*: any*/),
                                              (v10/*: any*/),
                                              (v37/*: any*/),
                                              (v69/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "configurables(first:99)"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "related(first:99)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "inWishlist",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8b852b4011d683eb84d2be95cec54b4a",
    "id": null,
    "metadata": {},
    "name": "routes_ProductView_Query",
    "operationKind": "query",
    "text": "query routes_ProductView_Query(\n  $urlSlugs: [String]\n) {\n  viewer {\n    ...CmsBanner_viewer\n    ...ShippingQuote_viewer\n    ...ReviewList_viewer\n    ...List_viewer\n    ...PriceMatch_viewer\n    ...ProductStock_viewer\n    ...Related_viewer\n    ...WishlistBtn_viewer\n    email\n    salesNumber\n    freeShippingAmount\n    products(first: 1, urlSlugs: $urlSlugs) {\n      edges {\n        node {\n          id\n          alerts\n          name\n          type\n          brand {\n            id\n            imageUrl\n            name\n            urlSlug\n          }\n          mainImage {\n            id\n            url\n            thumbnail\n          }\n          files(first: 99) {\n            edges {\n              node {\n                id\n                name\n                url\n              }\n            }\n          }\n          images {\n            url\n            thumbnail\n            id\n          }\n          model\n          bundles(first: 99) {\n            edges {\n              node {\n                id\n                name\n                model\n                sku\n                ac\n                description\n                specification\n                warranty\n                urlSlug\n                quantity\n                images(showInKit: true) {\n                  url\n                  thumbnail\n                  id\n                }\n              }\n            }\n          }\n          configurableAttributes\n          configurables(first: 99) {\n            edges {\n              node {\n                id\n                name\n                type\n                attributes\n                model\n                secondModel\n                sku\n                ac\n                regularPrice\n                price\n                priceMatch\n                description\n                specification\n                warranty\n                urlSlug\n                quantity\n                sellable\n                nonStock\n                onlineOnly\n                clearance\n                callForPrice\n                inStoreOnly\n                sortingFactor\n                videos\n                backInStockDate\n                stockAvailable\n                preorderDate\n                globalFreeShipping\n                freeShipping\n                ...TierPrice_product\n                tierPrices\n                discountCode\n                loyaltyPoints {\n                  accruing\n                  dollars\n                }\n                images(showInKit: true) {\n                  url\n                  thumbnail\n                  id\n                }\n                metaDescription\n                status\n                labels(first: 999) {\n                  edges {\n                    node {\n                      id\n                      imageUrl\n                      productPageImageUrl\n                      placement\n                    }\n                  }\n                }\n                bonusProducts(first: 999) {\n                  edges {\n                    node {\n                      productId\n                      productName\n                      productUrlSlug\n                      price\n                      quantity\n                      optional\n                      id\n                    }\n                  }\n                }\n                ...PriceMatch_product\n                ...ReviewForm_product\n                ...ReviewList_product\n                ...ProductStock_product\n                ...Freebie_product\n              }\n            }\n          }\n          secondModel\n          sortingFactor\n          sku\n          ac\n          description\n          specification\n          urlSlug\n          regularPrice\n          price\n          priceDrop\n          nonStock\n          onlineOnly\n          earnPoints\n          videos\n          backInStockDate\n          stockAvailable\n          preorderDate\n          globalFreeShipping\n          freeShipping\n          sellable\n          clearance\n          callForPrice\n          inStoreOnly\n          ...TierPrice_product\n          tierPrices\n          warranty\n          discountCode\n          loyaltyPoints {\n            accruing\n            dollars\n          }\n          metaDescription\n          status\n          commonPromoBanners\n          labels(first: 999) {\n            edges {\n              node {\n                id\n                imageUrl\n                productPageImageUrl\n                placement\n              }\n            }\n          }\n          bonusProducts(first: 999) {\n            edges {\n              node {\n                productId\n                productName\n                productUrlSlug\n                price\n                quantity\n                optional\n                id\n              }\n            }\n          }\n          suggestions(first: 12) {\n            edges {\n              node {\n                id\n                alerts\n                name\n                model\n                secondModel\n                price\n                sku\n                ac\n                urlSlug\n                freeShipping\n                preorderDate\n                backInStockDate\n                callForPrice\n                inStoreOnly\n                onlineOnly\n                discountCode\n                nonStock\n                sellable\n                clearance\n                brand {\n                  id\n                  name\n                }\n                labels(first: 999) {\n                  edges {\n                    node {\n                      id\n                      type\n                      imageUrl\n                      placement\n                    }\n                  }\n                }\n                mainImage {\n                  id\n                  thumbnail\n                }\n              }\n            }\n          }\n          ...PriceMatch_product\n          ...ReviewForm_product\n          ...ReviewList_product\n          ...ProductStock_product\n          ...Freebie_product\n          ...Related_product\n          ...WishlistBtn_product\n        }\n      }\n    }\n    ...ProductView_viewer\n    id\n  }\n}\n\nfragment CmsBanner_viewer on Customer {\n  cmsBanners(first: 999) {\n    edges {\n      node {\n        id\n        title\n        link\n        urlPaths\n        categoryBig\n        categorySmall\n      }\n    }\n  }\n}\n\nfragment Freebie_product on Product {\n  price\n  freebies(first: 99) {\n    edges {\n      node {\n        id\n        tiers(first: 99) {\n          edges {\n            node {\n              id\n              price\n              quantity\n              mode\n              products(first: 99) {\n                edges {\n                  node {\n                    id\n                    name\n                    urlSlug\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment List_viewer on Customer {\n  id\n  ...ProductCard_viewer\n}\n\nfragment PriceMatch_product on Product {\n  id\n  name\n  priceMatch\n}\n\nfragment PriceMatch_viewer on Customer {\n  id\n}\n\nfragment ProductCard_viewer on Customer {\n  id\n  freeShippingAmount\n}\n\nfragment ProductStock_product on Product {\n  id\n  ac\n  preorderDate\n  backInStockDate\n}\n\nfragment ProductStock_viewer on Customer {\n  id\n  email\n  myStore {\n    id\n  }\n}\n\nfragment ProductView_viewer on Customer {\n  ...CmsBanner_viewer\n  ...ShippingQuote_viewer\n  ...ReviewList_viewer\n  ...List_viewer\n  ...PriceMatch_viewer\n  ...ProductStock_viewer\n  ...Related_viewer\n  ...WishlistBtn_viewer\n  email\n  salesNumber\n  freeShippingAmount\n  products(first: 1, urlSlugs: $urlSlugs) {\n    edges {\n      node {\n        id\n        alerts\n        name\n        type\n        brand {\n          id\n          imageUrl\n          name\n          urlSlug\n        }\n        mainImage {\n          id\n          url\n          thumbnail\n        }\n        files(first: 99) {\n          edges {\n            node {\n              id\n              name\n              url\n            }\n          }\n        }\n        images {\n          url\n          thumbnail\n          id\n        }\n        model\n        bundles(first: 99) {\n          edges {\n            node {\n              id\n              name\n              model\n              sku\n              ac\n              description\n              specification\n              warranty\n              urlSlug\n              quantity\n              images(showInKit: true) {\n                url\n                thumbnail\n                id\n              }\n            }\n          }\n        }\n        configurableAttributes\n        configurables(first: 99) {\n          edges {\n            node {\n              id\n              name\n              type\n              attributes\n              model\n              secondModel\n              sku\n              ac\n              regularPrice\n              price\n              priceMatch\n              description\n              specification\n              warranty\n              urlSlug\n              quantity\n              sellable\n              nonStock\n              onlineOnly\n              clearance\n              callForPrice\n              inStoreOnly\n              sortingFactor\n              videos\n              backInStockDate\n              stockAvailable\n              preorderDate\n              globalFreeShipping\n              freeShipping\n              ...TierPrice_product\n              tierPrices\n              discountCode\n              loyaltyPoints {\n                accruing\n                dollars\n              }\n              images(showInKit: true) {\n                url\n                thumbnail\n                id\n              }\n              metaDescription\n              status\n              labels(first: 999) {\n                edges {\n                  node {\n                    id\n                    imageUrl\n                    productPageImageUrl\n                    placement\n                  }\n                }\n              }\n              bonusProducts(first: 999) {\n                edges {\n                  node {\n                    productId\n                    productName\n                    productUrlSlug\n                    price\n                    quantity\n                    optional\n                    id\n                  }\n                }\n              }\n              ...PriceMatch_product\n              ...ReviewForm_product\n              ...ReviewList_product\n              ...ProductStock_product\n              ...Freebie_product\n            }\n          }\n        }\n        secondModel\n        sortingFactor\n        sku\n        ac\n        description\n        specification\n        urlSlug\n        regularPrice\n        price\n        priceDrop\n        nonStock\n        onlineOnly\n        earnPoints\n        videos\n        backInStockDate\n        stockAvailable\n        preorderDate\n        globalFreeShipping\n        freeShipping\n        sellable\n        clearance\n        callForPrice\n        inStoreOnly\n        ...TierPrice_product\n        tierPrices\n        warranty\n        discountCode\n        loyaltyPoints {\n          accruing\n          dollars\n        }\n        metaDescription\n        status\n        commonPromoBanners\n        labels(first: 999) {\n          edges {\n            node {\n              id\n              imageUrl\n              productPageImageUrl\n              placement\n            }\n          }\n        }\n        bonusProducts(first: 999) {\n          edges {\n            node {\n              productId\n              productName\n              productUrlSlug\n              price\n              quantity\n              optional\n              id\n            }\n          }\n        }\n        suggestions(first: 12) {\n          edges {\n            node {\n              id\n              alerts\n              name\n              model\n              secondModel\n              price\n              sku\n              ac\n              urlSlug\n              freeShipping\n              preorderDate\n              backInStockDate\n              callForPrice\n              inStoreOnly\n              onlineOnly\n              discountCode\n              nonStock\n              sellable\n              clearance\n              brand {\n                id\n                name\n              }\n              labels(first: 999) {\n                edges {\n                  node {\n                    id\n                    type\n                    imageUrl\n                    placement\n                  }\n                }\n              }\n              mainImage {\n                id\n                thumbnail\n              }\n            }\n          }\n        }\n        ...PriceMatch_product\n        ...ReviewForm_product\n        ...ReviewList_product\n        ...ProductStock_product\n        ...Freebie_product\n        ...Related_product\n        ...WishlistBtn_product\n      }\n    }\n  }\n}\n\nfragment Related_product on Product {\n  related(first: 99) {\n    edges {\n      node {\n        id\n        brand {\n          id\n          name\n        }\n        name\n        type\n        nonStock\n        sku\n        price\n        urlSlug\n        callForPrice\n        mainImage {\n          id\n          thumbnail\n        }\n        configurables(first: 99) {\n          edges {\n            node {\n              id\n              name\n              type\n              nonStock\n              sku\n              price\n              urlSlug\n              callForPrice\n              mainImage {\n                id\n                thumbnail\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment Related_viewer on Customer {\n  id\n}\n\nfragment ReviewForm_product on Product {\n  id\n  name\n}\n\nfragment ReviewList_product on Product {\n  reviews(first: 100) {\n    edges {\n      node {\n        id\n        content\n        replies(first: 100) {\n          edges {\n            node {\n              id\n              content\n              customer {\n                firstname\n                id\n              }\n              customerName\n              insertedAt\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        ratings(first: 10) {\n          edges {\n            node {\n              id\n              star\n              percentage\n              ratingType {\n                code\n              }\n            }\n          }\n        }\n        product {\n          name\n          urlSlug\n          mainImage {\n            id\n            thumbnail\n          }\n          id\n        }\n        productName\n        customer {\n          id\n          firstname\n        }\n        customerName\n        insertedAt\n        status\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ReviewList_viewer on Customer {\n  id\n}\n\nfragment ShippingQuote_viewer on Customer {\n  freeShippingAmount\n  shippingMethods(first: 20, productId: \"\", suburb: \"\", city: \"\", postcode: \"\") {\n    edges {\n      node {\n        code\n        title\n        price\n        priceFormatted\n        extra\n        id\n      }\n    }\n  }\n}\n\nfragment TierPrice_product on Product {\n  price\n  tierPrices\n}\n\nfragment WishlistBtn_product on Product {\n  id\n  name\n  type\n  callForPrice\n  inStoreOnly\n  inWishlist\n  sellable\n}\n\nfragment WishlistBtn_viewer on Customer {\n  id\n  email\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '96bf19a2f172ffbe2d772e38f456decc';

module.exports = node;
